// extracted by mini-css-extract-plugin
module.exports = {"block":"CoverList_block__22bom","container":"CoverList_container__oXdYZ","home":"CoverList_home__Mz5_f","topcontainer":"CoverList_topcontainer__nV24f","box":"CoverList_box__rrgzV"};